import { useCallback, useMemo } from 'react';
import * as Sentry from '@sentry/react';
import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { useLocaleKeys } from '~/i18n';
import { mapOverviewItemToRow } from '../tabs/SummaryTab/cards/AgreementsOverviewCard/RecentAgreements.mapper';
const EMPTY_ROWS = [];
export function useRecentAgreements(customerId) {
    const { api } = useStoreActions();
    const { t: texts } = useLocaleKeys('client.detail.summary.agreementsOverview');
    const { data, isLoading, error, refresh, optimisticUpdate } = useQueryState({
        queryKey: [
            QueryKeys.RecentAgreements,
            customerId
        ],
        queryFn: ()=>api.client.getAgreementsOverview(customerId).then((response)=>response.items),
        enabled: true,
        refreshOnHookMount: true,
        keepPreviousData: false
    });
    const optimisticallyRemove = useCallback((id)=>optimisticUpdate((items)=>items.filter((item)=>item.id !== id)), [
        optimisticUpdate
    ]);
    const rows = useMemo(()=>data == null ? EMPTY_ROWS : toRows(data, texts), [
        data
    ]);
    return {
        rows,
        isLoading,
        isError: error != null,
        refetch: refresh,
        optimisticallyRemove
    };
}
function toRows(items, texts) {
    return items.reduce((rows, item)=>{
        const row = mapOverviewItemToRow(item, texts);
        if (row == null) {
            Sentry.captureMessage('Dropped unmappable recent-agreement item', {
                level: 'warning',
                tags: {
                    context: 'useRecentAgreements_dropped_item'
                },
                extra: {
                    id: item.id,
                    status: item.status
                }
            });
            return rows;
        }
        rows.push(row);
        return rows;
    }, []);
}
